module.exports = __webpack_public_path__ + "img/PERM.08063347.png";